import React from "react";
import { Legal, Languages } from "@arnaud-cortisse/donotskip-core";
import { useTranslation } from "../i18n";

interface AppPrivacyPolicyProps {
  src: string;
}
const PrivacyPolicy: React.FC<AppPrivacyPolicyProps> = () => {
  const { i18n } = useTranslation();

  const src = Legal?.PrivacyPolicyUrls[i18n.language as Languages.Ids];

  return (
    <div style={{ height: "100vh" }}>
      <iframe width="100%" height="100%" src={src} />
    </div>
  );
};

export default PrivacyPolicy;
